Ext.define('SA.FontPreloader', {
    singleton: true,

    preload() {
        var weights = [700, 800];

        weights.forEach(weight => {
            var el = SA.Html.create({
                type: 'div',
                content: '-', 
                style: {fontWeight: weight}
            });

            SA.HiddenDom.attach(el);
        });
    }
});